import { render, staticRenderFns } from "./StaleAssemblies.vue?vue&type=template&id=38a7bc9a"
import script from "./StaleAssemblies.vue?vue&type=script&lang=js"
export * from "./StaleAssemblies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports